<div
  class="customization-container d-flex flex-column align-items-center text-center mt-10 gap-32 w-100 h-100 pb-20"
  [@fadeAnimation]
>
  <div class="title" i18n="@@preliminaryProcessing">Preliminary processing...</div>

  <div class="position-relative" [@fadeAnimation]>
    <mat-spinner diameter="128" mode="determinate" [value]="value"></mat-spinner>

    <span class="main-color progress-label">{{ value }}%</span>
  </div>

  <div class="tasks w-100">
    <div class="task" [class.completed]="value >= 25">
      <i class="ri-check-line"></i>
      <div class="task-text" i18n="@@analyzingPreferences">Analyzing your preferences</div>
    </div>
    <div class="task" [class.completed]="value >= 50">
      <i class="ri-check-line"></i>
      <div class="task-text" i18n="@@preparingAiQuestions">Preparing questions for AI fine-tuning</div>
    </div>
    <div class="task" [class.completed]="value >= 75">
      <i class="ri-check-line"></i>
      <div class="task-text" i18n="@@lookingContentSamples">Looking for real content samples</div>
    </div>
    <div class="task" [class.completed]="value >= 100">
      <i class="ri-check-line"></i>
      <div class="task-text" i18n="@@finalizingSetup">Finalizing your personal setup</div>
    </div>
  </div>
</div>
